﻿import * as Model from '../../../models/models';
import * as Repositories from '../../../repositories/repositories';

export class SubmissionStateService {
    static $inject = ["$q", "submissionRepository"];

    public constructor(private $q: ng.IQService,
        private submissionRepository: Repositories.SubmissionRepository) {
        this.isReadOnly = false;
    }

    private submissionProfile: Model.ISubmissionProfile;

    public isReadOnly: boolean;

    // tslint:disable-next-line:variable-name
    private _submissionId: string;
    public get submissionId(): string { return this._submissionId; }
    public set submissionId(id: string) {
        this.reset();
        this._submissionId = id;
    }

    public submissionReferralStatus: SubmissionReferralStatus;

    public getSubmissionProfile(): ng.IPromise<Model.ISubmissionProfile> {
        if (angular.isUndefined(this.submissionProfile) || this.submissionProfile.submissionId !== this.submissionId) {
            return this.submissionRepository.getSubmissionProfile(this.submissionId)
                .then((profile: Model.ISubmissionProfile) => this.submissionProfile = profile);
        }
        else {
            return this.$q.when(this.submissionProfile);
        }
    }
    
    private reset(): void {
        this._submissionId = undefined;
        this.isReadOnly = false;
        this.submissionReferralStatus = SubmissionReferralStatus.unknown;
        this.submissionProfile = undefined;
    }

}

export enum SubmissionReferralStatus {
    unknown,
    quote,
    refer
}